import React from 'react';

export enum Env {
    Testing = 'testing',
    Production = 'production',
    Development = 'dev',
}

export default React.createContext<Env>(Env.Production);
